import React, { useEffect, useState } from 'react'
import './Movieedit.css'
import filterMoviesAndPersons from '../../Services/Queries/GetMovieListData'
// import getListMovies from '../../Services/Queries/GetListMovies'
import updateMoviePublished from '../../Services/Mutations/UpdateMoviePublished'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import BulkActions from './BulkActions'
import { ObjectValues, ObjectValuesNOEpisodes } from './objectsValues'
import { Auth } from 'aws-amplify'
import { ToastStyle } from '../Data/MovieStaticData'
import SearchBarinput from './SearchBarinput'

const replaceItem = (updater, index, item) =>
  updater(array => array.map((value, i) => (i === index ? item : value)))

const deleteItem = (updater, index) => updater(array => array.filter(i => i !== index))

const ListMovies = () => {
  const [LoaderServiceName, setLoaderServiceName] = useState('filterMoviesAndPersons')
  const [movieAndWebSeries, setMovieAndWebSeries] = useState('movies')
  const [lodeMoreDisble, setLodeMoreDisble] = useState(true)
  const [bulkActionName, setBulkActionName] = useState()
  const [searchListTrue, setSearchListTrue] = useState(false)
  const [searchValue, setSearch] = useState('')
  const [rolename, setRolename] = useState()
  const [personIdval, setpersonIdval] = useState()
  const [totalrenderedcount, setTotalRenderedCount] = useState(20)
  const [localMode, setLocalMode] = useState('read')
  const [isLoading, setIsLoading] = useState(false)
  const [movieFilterBy, setmovieFilterByFromSearch] = useState({})
  const [checkEmptyArray, setcheckEmptyArray] = useState(false)
  const [fromValue, setFromvalue] = useState(20)
  const [sortByorderFromLIst, setsortByorderFromLIst] = useState('desc')
  const [columns, setHeaders] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([])
  const [checkBoxArr, setCheckBoxArr] = useState([])
  const [checkSelectedArrayLength, setcheckSelectedArrayLength] = useState(0)
  const [checkSelectedArray, setcheckSelectedArray] = useState()
  // const [getnextToken, setGetNextToken] = useState(null)
  const [ListMoviesDataItems, setListMoviesDataItems] = useState([])
  const [statusType, setstatusType] = useState('published')
  const [filterDisableWithoutSelect, setfilterDisableWithoutSelect] = useState(true)
  const [disapperAllFilters, setDisapperAllFilters] = useState(true)
  const [sortBy, setsortBy] = useState('releaseYear')
  const [searchQuery, setSearchQuery] = useState('')
  const handleStatusType = value => setstatusType(value)

  const handleMovieAndWebSeries = e => setMovieAndWebSeries(e.target.value)

  const updateData = (index, fieldname, fieldValue) => {
    setListMoviesDataItems(prevItems => [
      ...prevItems.slice(0, index),
      { ...prevItems[index], [fieldname]: fieldValue },
      ...prevItems.slice(index + 1),
    ])
  }

  const handleChange = (rowIndex, changedRowData) => replaceItem(setData, rowIndex, changedRowData)

  const checkboxfunction = ({ id, name, sendTFIDBPN }) => {
    // const { name, id } = e.target
    const updatedArray = checkBoxArr.filter(item => item.PK !== name)
    const newCheckBoxArr =
      updatedArray.length === checkBoxArr.length
        ? [...checkBoxArr, { PK: name, SK: id, sendTFIDBPN }]
        : updatedArray

    const filteredCheckDeleted = newCheckBoxArr.filter(
      x => !ListMoviesDataItems.map(item => item.pk).includes(x.PK),
    )

    setCheckBoxArr(newCheckBoxArr)
    setcheckSelectedArray(filteredCheckDeleted)
    setcheckSelectedArrayLength(newCheckBoxArr.length)
  }

  const handleDelete = rowIndex => {
    deleteItem(setData, rowIndex)
    setBulkActionName('Delete')
  }

  const handleActions = e => setBulkActionName(e.target.value)

  const updatePublishedMovies = async (status, item) => {
    const loggedInUserEmail = Auth.user.attributes?.email || ''
    const publishedListUpdate = {
      status,
      PK: item.PK,
      SK: item.SK,
      ...(item.sendTFIDBPN && { sendTFIDBPN: item.sendTFIDBPN }),
      moderatorID: Auth.user.username,
      moderatorHandle: '@' + loggedInUserEmail.split('@')[0],
    }

    const publishedMovies = await updateMoviePublished(publishedListUpdate)
    const { statusCode } = publishedMovies.data.updateMovieStatus

    return { publishedListUpdate, statusCode }
  }

  const handleOperation = async (e, operation, successMessage) => {
    setIsLoading(true)
    const deleteArray = [{ PK: e.PK, SK: e.SK, sendTFIDBPN: e.sendTFIDBPN }]
    const updatePromises = deleteArray.map(async item => {
      const { publishedListUpdate, statusCode } = await updatePublishedMovies(
        operation === 'Approve' ? 'published' : 'deleted',
        item,
      )

      const remainingElements = ListMoviesDataItems?.filter(elem => elem.PK !== item.PK)

      if (statusCode === 'A367') {
        setListMoviesDataItems(remainingElements)
        toast.success(`${movieAndWebSeries} ${successMessage} Successfully`, ToastStyle)
      }

      return publishedListUpdate
    })

    await Promise.all(updatePromises)

    setIsLoading(false)
  }

  const approveMovie = async e => {
    await handleOperation(e, 'Approve', 'Approved')
  }

  const handleDeleteClick = async e => {
    await handleOperation(e, 'delete', 'Deleted')
  }

  const Limit = 20

  // useEffect(() => {
  //   const getListMoviesDetails = async () => {
  //     setIsLoading(true)
  //     const input = {
  //       contentType: movieAndWebSeries,
  //       status: statusType,
  //       limit: Limit,
  //       sortOrder: sortByorderFromLIst,
  //       sortBy,
  //     }
  //     setCheckBoxArr([]) // Reset array when status changes

  //     const { nextToken, items } = await getListMovies(input)

  //     setGetNextToken(nextToken)
  //     setcheckEmptyArray(false)
  //     setLodeMoreDisble(nextToken === null)
  //     setListMoviesDataItems(items)

  //     if (items.length > 0) {
  //       const tableHeaders = movieAndWebSeries === 'movies' ? ObjectValues : ObjectValuesNOEpisodes
  //       const finalHeaders = tableHeaders
  //         .map(item => ({ path: item, name: item }))
  //         .filter(item => item.name !== 'PK' && item.name !== 'SK' && item.name !== '__typename')

  //       setHeaders(finalHeaders)
  //     }

  //     setIsLoading(false)
  //   }

  //   setLoaderServiceName('getListMovies')
  //   getListMoviesDetails()
  // }, [statusType, movieAndWebSeries])
  useEffect(() => {
    const getListMoviesDetails = async () => {
      setSearch('')
      setSearchQuery('')
      setIsLoading(true)
      // const input = {
      //   contentType: movieAndWebSeries,
      //   status: statusType,
      //   limit: 20,
      //   sortOrder: sortByorderFromLIst,
      //   sortBy,
      // }
      const input = {
        limit: Limit,
        sortOrder: sortByorderFromLIst,
      }
      input.from = 0
      input.search = ''
      input.sortBy = sortBy
      input.type = movieAndWebSeries
      // if (Object.keys(movieFilterBy).length >= 1) {
      movieFilterBy.status = statusType
      input.movieFilterBy = movieFilterBy
      setCheckBoxArr([]) // Reset array when status changes

      const movieList = await filterMoviesAndPersons(input)
      const arrayList = [...movieList.items]

      setListMoviesDataItems(arrayList)
      setFromvalue(Limit)
      setTotalRenderedCount(Limit)
      // console.log(, 'totalrendered===')
      if (arrayList.length < movieList.total) {
        if (movieList.items.length === 0) {
          setLodeMoreDisble(true)
        } else {
          setLodeMoreDisble(false)
        }
      } else {
        setLodeMoreDisble(true)
      }

      setcheckEmptyArray(false)
      // setLodeMoreDisble(true)
      // setListMoviesDataItems(items)

      if (arrayList.length > 0) {
        const tableHeaders = movieAndWebSeries === 'movies' ? ObjectValues : ObjectValuesNOEpisodes
        const finalHeaders = tableHeaders
          .map(item => ({ path: item, name: item }))
          .filter(item => item.name !== 'PK' && item.name !== 'SK' && item.name !== '__typename')

        setHeaders(finalHeaders)
      }

      setIsLoading(false)
    }

    setLoaderServiceName('filterMoviesAndPersons')
    getListMoviesDetails()
  }, [statusType, movieAndWebSeries])

  const handleLoadMore = async () => {
    setIsLoading(true)
    const input = {
      limit: Limit,
      sortOrder: sortByorderFromLIst,
    }
    if (LoaderServiceName === 'filterMoviesAndPersons') {
      input.from = fromValue
      input.search = searchValue
      input.sortBy = sortBy
      input.type = movieAndWebSeries
      // if (Object.keys(movieFilterBy).length >= 1) {
      movieFilterBy.status = statusType
      input.movieFilterBy = movieFilterBy
      // }

      const movieList = await filterMoviesAndPersons(input)
      const arrayList = movieList.items && [...ListMoviesDataItems, ...movieList.items]

      setListMoviesDataItems(arrayList)
      setFromvalue(fromValue + Limit)
      setTotalRenderedCount(totalrenderedcount + Limit)
      // console.log(totalrenderedcount + Limit, 'limit===')
      if (arrayList.length < movieList.total) {
        if (movieList.items.length === 0) {
          setLodeMoreDisble(true)
        } else {
          setLodeMoreDisble(false)
        }
      } else {
        setLodeMoreDisble(true)
      }
    }
    //  else if (LoaderServiceName === 'getListMovies') {
    //   setIsLoading(true)
    //   input.contentType = movieAndWebSeries
    //   input.status = statusType
    //   input.nextToken = getnextToken
    //   input.sortBy = sortBy
    //   const ListMoviesData = await getListMovies(input)

    //   if (getnextToken !== null) {
    //     setListMoviesDataItems([...ListMoviesDataItems, ...ListMoviesData.items])
    //     setGetNextToken(ListMoviesData.nextToken)
    //   }

    //   setIsLoading(false)

    //   if (ListMoviesData.nextToken === null) {
    //     setLodeMoreDisble(true)
    //   } else {
    //     setLodeMoreDisble(false)
    //   }
    // }

    setIsLoading(false)
  }

  const handlePublishedStatus = e => setstatusType(e.target.value)

  const closeSearchAndDatePicker = () => setSearchListTrue(false)

  const updateSearchValue = value => setSearch(value)

  return (
    <div onClick={closeSearchAndDatePicker}>
      <SearchBarinput
        updateSearchValue={updateSearchValue}
        movieAndWebSeries={movieAndWebSeries}
        handleMovieAndWebSeries={handleMovieAndWebSeries}
        setSearchListTrue={setSearchListTrue}
        statusType={statusType}
        searchValue={searchValue}
        searchListTrue={searchListTrue}
        isLoading={isLoading}
        setSearch={setSearch}
        setDisapperAllFilters={setDisapperAllFilters}
        setfilterDisableWithoutSelect={setfilterDisableWithoutSelect}
        setMovieAndWebSeries={setMovieAndWebSeries}
        setLoaderServiceName={setLoaderServiceName}
        disapperAllFilters={disapperAllFilters}
        setTotalRenderedCount={setTotalRenderedCount}
        setIsLoading={setIsLoading}
        filterDisableWithoutSelect={filterDisableWithoutSelect}
        handleStatusType={handleStatusType}
        sortByorderFromLIst={sortByorderFromLIst}
        setsortByorderFromLIst={setsortByorderFromLIst}
        handlePublishedStatus={handlePublishedStatus}
        setcheckEmptyArray={setcheckEmptyArray}
        setmovieFilterByFromSearch={setmovieFilterByFromSearch}
        setCheckBoxArr={setCheckBoxArr}
        setLodeMoreDisble={setLodeMoreDisble}
        setFromvalue={setFromvalue}
        movieFilterBy={movieFilterBy}
        setListMoviesDataItems={setListMoviesDataItems}
        // setGetNextToken={setGetNextToken}
        setHeaders={setHeaders}
        sortBy={sortBy}
        setsortBy={setsortBy}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />{' '}
      <BulkActions
        movieAndWebSeries={movieAndWebSeries}
        setIsLoading={setIsLoading}
        bulkActionName={bulkActionName}
        checkBoxArr={checkBoxArr}
        ListMoviesDataItems={ListMoviesDataItems}
        checkSelectedArray={checkSelectedArray}
        setListMoviesDataItems={setListMoviesDataItems}
        setCheckBoxArr={setCheckBoxArr}
        setLocalMode={setLocalMode}
        localMode={localMode}
        rolename={rolename}
        personIdval={personIdval}
        setpersonIdval={setpersonIdval}
        setRolename={setRolename}
        checkEmptyArray={checkEmptyArray}
        checkSelectedArrayLength={checkSelectedArrayLength}
        handleActions={handleActions}
        handleDelete={handleDelete}
        lodeMoreDisble={lodeMoreDisble}
        handleLoadMore={handleLoadMore}
        columns={columns}
        // ListMoviesDataNew={ListMoviesDataNew}
        handleChange={handleChange}
        updateData={updateData}
        approveMovie={approveMovie}
        handleDeleteClick={handleDeleteClick}
        checkboxfunction={checkboxfunction}
        statusType={statusType}
      />
    </div>
  )
}

export default ListMovies
